import React from 'react';
import api from '../../../../Api';

export const Action = {
	SET_EDITOR_VALUE: 'SET_EDITOR_VALUE',
	RESET_EDITOR_VALUE: 'RESET_EDITOR_VALUE',
	CLEAR_CURRENT_REVIEW: 'CLEAR_CURRENT_REVIEW',
	SET_HAS_EXISTING_REVIEW: 'SET_HAS_EXISTING_REVIEW',
};

export default function useReviewEditor(sku) {
	const [isLoading, setIsLoading] = React.useState(true);
	const [hasExistingReview, setHasExistingReview] = React.useState(false);

	const initialEmptyReviewState = {
		abstract: '',
		appUserId: 0,
		assessmentId: 0,
		overallAssessment: 0,
		text: '',
		titleName: '',
	};

	const [review, setReview] = React.useState(initialEmptyReviewState);

	const [editor, setEditor] = React.useState({
		value: '',
	});

	React.useEffect(() => {
		let request;

		const fetchReview = async () => {
			request = api.cancelableGet(`/api/me/reviews/${sku}/review`);
			const currentReview = await request.promise;

			if (currentReview) {
				const { text } = currentReview;

				setReview(currentReview);

				setEditor(current => ({
					...current,
					value: text ? text : '',
				}));

				setHasExistingReview(true);
			}

			setIsLoading(false);
		};

		fetchReview();

		return () => {
			api.revoke(request);
		};
	}, [sku]);

	const reduceState = action => {
		switch (action.type) {
			case Action.SET_EDITOR_VALUE:
				setEditor(current => ({ ...current, value: action.payload }));
				break;
			case Action.RESET_EDITOR_VALUE:
				setEditor(current => ({ ...current, value: review.text }));
				break;
			case Action.CLEAR_CURRENT_REVIEW:
				setEditor({ value: '' });
				setReview(initialEmptyReviewState);
				break;
			case Action.SET_HAS_EXISTING_REVIEW:
				setHasExistingReview(action.payload);
				break;
			case Action.default:
				break;
		}
	};

	return {
		currentReview: review,
		isLoading: () => isLoading,
		getEditorValue: () => editor.value,
		getSavedValue: () => (review.text ? review.text : ''),
		update: action => reduceState(action),
		doesReviewExist: () => hasExistingReview,
		hasExistingAssessment: () => review.assessmentId > 0,
		didEdit: () => review.text && review.text !== editor.value,
	};
}
